import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { AliquotaIbsService } from '@shared/services/apis/motor-fiscal/aliquota-ibs.service';
import { AliquotaCbsStruct } from '@shared/services/structs/motor-fiscal/aliquota-cbs.struct';
import { AlertService, AlertType } from '@shared/services/alert.service';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { LoadingBoxDefaultListComponent } from '@shared/components/loading-box-default-list/loading-box-default-list.component';
import { AliquotaIbsEditDialogComponent, AliquotaIbsEditDialogData, AliquotaIbsEditDialogResult } from '../aliquota-ibs-edit-dialog/aliquota-ibs-edit-dialog.component';

/** Alíquota da CBS vigente (base global ou override da empresa). Salvamento direto. */
@Component({
    selector: 'app-aliquota-cbs-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatTableModule,
        EmptyStateComponent,
        LoadingBoxDefaultListComponent,
    ],
    templateUrl: './aliquota-cbs-dialog.component.html',
    styleUrl: './aliquota-cbs-dialog.component.css',
})
export class AliquotaCbsDialogComponent implements OnInit {
    public isLoading = false;
    /** Gravação da alíquota pelo menu da linha: spinner no botão de ações, desabilitado até voltar. */
    public isSalvando = false;
    public displayedColumns = ['aliquota', 'vigencia', 'actions'];
    public linhas: AliquotaCbsStruct[] = [];

    constructor(
        private dialogRef: MatDialogRef<AliquotaCbsDialogComponent>,
        private dialog: MatDialog,
        private aliquotaService: AliquotaIbsService,
        private alertService: AlertService,
    ) {}

    ngOnInit(): void {
        this.carregar();
    }

    private carregar(): void {
        this.isLoading = true;
        this.aliquotaService.getCbs().subscribe({
            next: response => {
                this.isLoading = false;
                if (response?.isError) {
                    this.alertService.show('Aviso', response.errorDescription || 'Não foi possível carregar a alíquota da CBS.', AlertType.warning);
                    return;
                }
                this.linhas = response.aliquota ? [response.aliquota] : [];
            },
            error: () => {
                this.isLoading = false;
                this.alertService.show('Aviso', 'Não foi possível carregar a alíquota da CBS. Tente novamente em alguns instantes.', AlertType.warning);
            },
        });
    }

    public editar(linha: AliquotaCbsStruct): void {
        const data: AliquotaIbsEditDialogData = {
            titulo: 'Alíquota CBS',
            descricao: 'CBS - alíquota nacional',
            pAliquota: linha.pAliquota,
        };
        const ref = this.dialog.open(AliquotaIbsEditDialogComponent, { width: '420px', maxWidth: '95vw', data });
        ref.afterClosed().subscribe((result: AliquotaIbsEditDialogResult | undefined) => {
            if (!result) return;
            this.isSalvando = true;
            this.aliquotaService.salvarCbs({ pAliquota: result.pAliquota }).subscribe({
                next: r => {
                    this.isSalvando = false;
                    if (r?.isError) {
                        this.alertService.show('Aviso', r.errorDescription || 'Não foi possível salvar a alíquota.', AlertType.warning);
                        return;
                    }
                    linha.pAliquota = result.pAliquota;
                    linha.personalizada = true;
                    this.alertService.show('Sucesso', 'Alíquota salva com sucesso.', AlertType.success);
                },
                error: () => {
                    this.isSalvando = false;
                    this.alertService.show('Aviso', 'Não foi possível salvar a alíquota. Tente novamente em alguns instantes.', AlertType.warning);
                },
            });
        });
    }

    public fechar(): void {
        this.dialogRef.close();
    }
}
